// Basic global alias used by some RN deps on web
// IMPORTANT: do NOT define global `module/exports/require` here.
// Doing so triggers UMD/commonjs branches in some libs and breaks webpack bundling.
if (typeof globalThis.global === 'undefined') {
  globalThis.global = globalThis;
}
